import React, { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import MultiStepFormContext from "~/contexts/MultiSelectForm/MultiSelectFormContext";
import Button from "~/shared/Btn";
import TextareaInput from "~/shared/TextareaInput";
import TextInput from "~/shared/TextInput";
import NumberInput from "~/shared/NumberInput";
import { Content, Header, Footer } from "../styles";
import { Row, Col } from "react-bootstrap";

type PetsProps = {
    prevStep?: () => void;
    nextStep?: () => void;
    goToStep?: (step: number) => void;
    currentStep: number;
};

const extraFields = {
    pet_type: {
        name: "Tipo de pet",
        value: "",
        type: "texto",
    },
    number_of_pets: {
        name: "Numero de pets",
        value: "",
        type: "numero",
    },
    number_of_photos: {
        name: "Numero de fotos por pet",
        value: "",
        type: "numero",
    },
    adicional_info: {
        name: "Informações adicionais",
        value: "",
        type: "texto",
    },
};

const Pets = ({ nextStep, goToStep }: PetsProps) => {
    const { values, confirmationStep, handleChange, updateValuesInLocalStorage, setValues } =
        useContext(MultiStepFormContext);

    const [addicionalInfo, setAddicionalInfo] = useState<string>(values?.extra?.adicional_info?.value || "");
    const [petType, setPetType] = useState<string>(values?.extra?.pet_type?.value || "");
    const [numberOfPets, setNumberOfPets] = useState<string>(values?.extra?.number_of_pets?.value || "");
    const [numberOfPhotos, setNumberOfPhotos] = useState<string>(values?.extra?.number_of_photos?.value || "");

    const briefing = `Informações\nQual meu pet?: ${values?.extra?.pet_type?.value || petType}\nNúmero de Pets: ${
        values?.extra?.number_of_pets?.value || numberOfPets
    }\nNúmero aproximado de fotos: ${values?.extra?.number_of_photos?.value || numberOfPets}`;

    const handleExtraFieldChange = async (name: string, value: any) => {
        if (Object.keys(extraFields).includes(name)) {
            handleChange(name, { ...extraFields[name], value, type: extraFields[name].type }, { extra: true });
        }
    };

    const validateAndNextStep = () => {
        if (!petType.length || !numberOfPets.length || !numberOfPhotos.length) {
            return toast.error("Os campos de informações são obrigatórios!");
        }

        if (confirmationStep) {
            updateValuesInLocalStorage();
            return goToStep(confirmationStep);
        }

        return nextStep();
    };

    useEffect(() => {
        const localValues = JSON.parse(localStorage.getItem("values"));
        if (confirmationStep) {
            setValues(localValues);
        }
    }, []);

    useEffect(() => {
        handleChange("briefing", briefing);
    }, [briefing]);

    return (
        <>
            <Header>
                <h1>Defina o briefing do seu job</h1>
                <p>Precisamos de algumas informações para realizar o seu job!</p>
            </Header>

            <Content>
                <div className="title">
                    <p>Informações</p>
                    <div className="bar" />
                    <Row className="input-content">
                        <Col lg={4}>
                            <TextInput
                                name="pet_type"
                                label="Qual meu pet?"
                                value={petType}
                                onChange={(name: string, value: string) => {
                                    handleExtraFieldChange(name, value);
                                    setPetType(value);
                                }}
                            />
                        </Col>

                        <Col lg={4}>
                            <NumberInput
                                name="number_of_pets"
                                label="Número de Pets"
                                value={numberOfPets}
                                onChange={(name: string, value: string) => {
                                    handleExtraFieldChange(name, value);
                                    setNumberOfPets(value);
                                }}
                            />
                        </Col>
                        <Col lg={4}>
                            <NumberInput
                                name="number_of_photos"
                                label="Número aproximado de fotos"
                                value={numberOfPhotos}
                                onChange={(name: string, value: string) => {
                                    handleExtraFieldChange(name, value);
                                    setNumberOfPhotos(value);
                                }}
                            />
                        </Col>
                    </Row>
                </div>
            </Content>
            <Content>
                <div className="title">
                    <p>Informações adicionais</p>
                    <div className="bar" />
                    <TextareaInput
                        name="adicional_info"
                        value={addicionalInfo}
                        placeholder="Descreva aqui qualquer informação adicional..."
                        rows={3}
                        onChange={(name: string, value: string) => {
                            handleExtraFieldChange(name, value);
                            setAddicionalInfo(value);
                        }}
                    />
                </div>
            </Content>

            <Footer>
                {confirmationStep ? (
                    <Button block onClick={validateAndNextStep}>
                        Salvar
                    </Button>
                ) : (
                    <>
                        <Button id="clickSegmentNext" block onClick={() => handleChange("category", 0)}>
                            Voltar
                        </Button>
                        <Button id="clickSegmentNext" block onClick={validateAndNextStep}>
                            Continuar
                        </Button>
                    </>
                )}
            </Footer>
        </>
    );
};

export default Pets;
